import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { Challenge, CreateChallengePayload } from '../types'

export const challengesApi = {
  fetchAll: () => apiClient.get<ApiResponse<Challenge[]>>('/challenges'),

  create: (payload: CreateChallengePayload) =>
    apiClient.post<ApiResponse<Challenge>>('/challenges', payload),

  invite: (challengeId: string, userId: string) =>
    apiClient.post(`/challenges/${challengeId}/invite`, { user_id: userId }),

  respond: (challengeId: string, answer: 'accept' | 'decline' | 'leave') =>
    apiClient.post(`/challenges/${challengeId}/respond`, { answer }),
}
